import React from 'react';
import { useDrag, useDragLayer } from 'react-dnd';
import Draggable from './Draggable';
import { Paper } from 'components'

const layerStyles = {
    position: "absolute",
    pointerEvents: "none",
    zIndex: 3000,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    borderRadius: '5px',
};

function getItemStyles(initialOffset, currentOffset, itemWidth, style) {
    if (!initialOffset || !currentOffset) {
      return {
        display: "none"
      };
    }

    // Positioning
    let { x, y } = currentOffset;
    const transform = `translate(${x}px, ${y + window.scrollY}px)`;

    // Final style
    return {
      transform,
      WebkitTransform: transform,
      width: itemWidth,
      padding: style.padding || '0',
      border: style.secondaryColor ? `1px solid ${style.secondaryColor}` : '1px solid var(--primary-accent2-color)',
      opacity: '100%',
      borderRadius: '5px',
      backgroundColor: style.primaryColor || 'var(--primary-color)',
      cursor: 'grabbing',
      boxSizing: 'border-box',
      boxShadow: `0px 2px 1px -1px ${style.secondaryColor || 'var(--primary-accent2-color)'},` + 
                  `0px 1px 1px 0px ${style.secondaryColor || 'var(--primary-accent2-color)'}, ` +
                  `0px 1px 3px 0px ${style.secondaryColor || 'var(--primary-accent2-color)'}`
    };
  }

export const CustomDragLayer = (props) => {
    const {
        item,
        itemType,
        isDragging,
        initialOffset,
        currentOffset,
        clientOffset,
      } = useDragLayer((monitor) => {
        return (
          {
            item: monitor.getItem(),
            itemType: monitor.getItemType(),
            isDragging: monitor.isDragging(),
            initialOffset: monitor.getInitialSourceClientOffset(),
            currentOffset: monitor.getSourceClientOffset(),
            clientOffset: monitor.getClientOffset()
          }
        )
      })
    
    if (!isDragging) {
        return null;
    }
    const style = {
      primaryColor: item.props.primaryColor,
      secondaryColor: item.props.secondaryColor,
      padding: item.props.padding
    };

    return (
      <div style={layerStyles} id={item.props.id}>
        <div style={getItemStyles(initialOffset, currentOffset, item.width, style)}>
            {item.props.preview || <Draggable {...item.props}/>}          
        </div>
      </div>
    )
}

export default CustomDragLayer;